import pin from "../../../images/map-marker-alt-solid.png";
import pdfIcon from "../../../images/pdf-download.png";
import activeShadow from "../../../images/active-shadow.png";
import downloadIcon from "../../../images/blue-download.png";

export default (theme) => ({
  ProductFaqs: {
    position: "relative",
    // marginBottom: 36,
    zIndex: 0,
    "& h2": {
      fontSize: 18,
      letterSpacing: "0",
      lineHeight: 1.5,
      // marginTop: 60,
      [theme.breakpoints.up("md")]: {
        marginTop: 30,
        fontSize: 32,
        letterSpacing: "0.008em",
        marginBottom: 0,
      },
    },
    "& .product-faqs": {
      position: "relative",
      width: "calc(100% - 24px)",
      marginLeft: 12,
      paddingBlock: '36px',
      [theme.breakpoints.up("md")]: {
        paddingBlock: '60px',
        width: "calc(87.5% - 24px)",
        marginLeft: "calc(6.25% + 12px)",
      },
      [theme.breakpoints.up("lg")]: {
        paddingBlock: '100px',
      },
      "&:before": {
        content: "''",
        display: "block",
        position: "absolute",
        backgroundColor: "#ecedef",
        top: 0,
        bottom: 0,
        width: "100vw",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: -1,
      },
      "& h2": {
        marginBottom: 32,
      },
      "& .MuiPaper-root": {
        backgroundColor: "transparent",
      },
      "& .accordion": {
        maxWidth: "100%",
        marginLeft: 0,
        marginRight: 0,
      },
    },
  },
  ProductFaqsTheme: {
    ...theme.ProductFaqsTheme,
  },
});
